import { render, staticRenderFns } from "./MaterialPriceApplicationList.vue?vue&type=template&id=2b163684&"
import script from "./MaterialPriceApplicationList.vue?vue&type=script&lang=js&"
export * from "./MaterialPriceApplicationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports